<div class="product-offers-container">
    <ng-container *ngIf="showPrimaryOfferRow()">
        <div class="offers-header">
            <span class="header-label pl-0">Supplier</span>
            <span class="header-label">Availability</span>
            <span class="header-label">Price with delivery</span>
            <span class="header-label">Shipping Date</span>
            <span class="header-label offers-count" *ngIf="!supplierId">
                {{ getVisibleVariants().length || 0 }}
                {{ getVisibleVariants().length === 1 ? "offer" : "offers" }}
            </span>
        </div>

        <div *ngIf="!isShowingAllOffers(product)" class="offer-row">
            <div class="offer-row-inner">
                <div class="offer-cell supplier-cell product-list__blur-container" [class.product-list__blurred]="guestCellBlur">
                    <span class="mobile-label">SUPPLIER</span>
                    <a
                        *ngIf="isValidSupplierId(getDisplayVariant()?.supplierId)"
                        [routerLink]="[
                            '/category/products',
                            getDisplayVariant().supplierId
                        ]"
                        class="supplier-link"
                    >
                        #{{ getDisplayVariant().supplierId }}
                    </a>
                    <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                </div>

                <div class="offer-cell product-list__blur-container" [class.product-list__blurred]="guestCellBlur">
                    <span class="mobile-label">AVAILABILITY</span>
                    <span class="availability-text" [class.text-red-600]="getAvailabilityDisplay(getDisplayVariant()) === TEXT.OUT_OF_STOCK" [class.font-normal]="getAvailabilityDisplay(getDisplayVariant()) === TEXT.OUT_OF_STOCK">
                        {{ getAvailabilityDisplay(getDisplayVariant()) }}
                    </span>
                    <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                </div>

                <div class="offer-cell product-list__blur-container" [class.product-list__blurred]="guestCellBlur">
                    <span class="mobile-label">PRICE</span>
                    <span class="price-text !font-medium">
                        {{ getDisplayVariant().priceWithTax | formatPrice }}
                    </span>
                    <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                </div>

                <div class="offer-cell">
                    <span class="mobile-label">SHIPPING DATE</span>
                    <span class="shipping-date-text !font-normal">
                        {{ getShippingDateDisplay(getDisplayVariant()) }}
                    </span>
                </div>

                <div class="offer-cell actions-cell" [class.product-list__blurred]="guestCellBlur">
                    <div class="actions-wrapper">
                        <div class="actions-row">
                            <div class="quantity-controls">
                                <button
                                    class="qty-btn qty-btn-minus"
                                    (click)="
                                        decreaseQuantity(
                                            product.productId,
                                            getDisplayVariant().id
                                        )
                                    "
                                >
                                    <img src="assets/icons/minus-icon.svg" alt="Decrease quantity" class="qty-btn__icon" />
                                </button>
                                <input
                                    type="text"
                                    class="qty-input"
                                    [value]="
                                        getQuantity(
                                            product.productId,
                                            getDisplayVariant().id
                                        )
                                    "
                                    (input)="
                                        onQuantityChange(
                                            $event.target.value,
                                            product.productId,
                                            getDisplayVariant().id
                                        )
                                    "
                                />
                                <button
                                    class="qty-btn qty-btn-plus"
                                    (click)="
                                        increaseQuantity(
                                            product.productId,
                                            getDisplayVariant().id
                                        )
                                    "
                                >
                                    <img src="assets/icons/plus-icon.svg" alt="Increase quantity" class="qty-btn__icon" />
                                </button>
                            </div>
                            <button
                                class="add-to-cart-btn"
                                (click)="
                                    onAddToCart(
                                        product.productId,
                                        getDisplayVariant().id,
                                        getQuantity(
                                            product.productId,
                                            getDisplayVariant().id
                                        )
                                    )
                                "
                            >
                                <img
                                    alt="Add to Cart"
                                    src="assets/icons/cart-icon-white.svg"
                                    class="cart-icon"
                                />
                            </button>
                        </div>
                        <span class="moq-text" *ngIf="getDisplayVariant() && !hasMinQ(getDisplayVariant()) && getMoq(getDisplayVariant()) > 1">
                            {{ TEXT.MOQ_PREFIX }} {{ getMoq(getDisplayVariant()) }} {{ TEXT.MOQ_SUFFIX }}
                        </span>
                        <span class="product-table__quantity-info" *ngIf="getDisplayVariant() && hasMinQ(getDisplayVariant())">
                            {{ getQuantityInfoText(getDisplayVariant()) }}
                        </span>
                        <span class="product-table__quantity-info" *ngIf="getDisplayVariant() && getBundleLabel(getDisplayVariant(), product) as bundleLabel">
                            {{ bundleLabel }}
                        </span>
                    </div>
                    <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="isShowingAllOffers(product)">
            <ng-container
                *ngFor="let variant of getVisibleVariants(); let i = index"
            >
                <div
                    class="offer-row"
                    [class.offer-row-alt]="i % 2 === 1"
                    *ngIf="showOfferForVariant(variant)"
                >
                    <div class="offer-row-inner">
                        <div class="offer-cell supplier-cell product-list__blur-container" [class.product-list__blurred]="guestCellBlur">
                            <span class="mobile-label">SUPPLIER</span>
                            <a
                                *ngIf="isValidSupplierId(variant.supplierId)"
                                [routerLink]="[
                                    '/category/products',
                                    variant.supplierId
                                ]"
                                class="supplier-link"
                            >
                                #{{ variant.supplierId }}
                            </a>
                            <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                        </div>

                        <div class="offer-cell product-list__blur-container" [class.product-list__blurred]="guestCellBlur">
                            <span class="mobile-label">AVAILABILITY</span>
                            <span class="availability-text" [class.text-red-600]="getAvailabilityDisplay(variant) === TEXT.OUT_OF_STOCK" [class.font-normal]="getAvailabilityDisplay(variant) === TEXT.OUT_OF_STOCK">
                                {{ getAvailabilityDisplay(variant) }}
                            </span>
                            <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                        </div>

                        <div class="offer-cell product-list__blur-container" [class.product-list__blurred]="guestCellBlur">
                            <span class="mobile-label">PRICE</span>
                            <span class="price-text">
                                {{ variant.priceWithTax | formatPrice }}
                            </span>
                            <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                        </div>

                        <div class="offer-cell">
                            <span class="mobile-label">SHIPPING DATE</span>
                            <span class="shipping-date-text">
                                {{ getShippingDateDisplay(variant) }}
                            </span>
                        </div>

                        <div class="offer-cell actions-cell" [class.product-list__blurred]="guestCellBlur">
                            <div class="actions-wrapper">
                                <div class="actions-row">
                                    <div class="quantity-controls">
                                        <button
                                            class="qty-btn qty-btn-minus"
                                            (click)="
                                                decreaseQuantity(
                                                    product.productId,
                                                    variant.id
                                                )
                                            "
                                        >
                                            <img src="assets/icons/minus-icon.svg" alt="Decrease quantity" class="qty-btn__icon" />
                                        </button>
                                        <input
                                            type="text"
                                            class="qty-input"
                                            [value]="
                                                getQuantity(
                                                    product.productId,
                                                    variant.id
                                                )
                                            "
                                            (input)="
                                                onQuantityChange(
                                                    $event.target.value,
                                                    product.productId,
                                                    variant.id
                                                )
                                            "
                                        />
                                        <button
                                            class="qty-btn qty-btn-plus"
                                            (click)="
                                                increaseQuantity(
                                                    product.productId,
                                                    variant.id
                                                )
                                            "
                                        >
                                            <img src="assets/icons/plus-icon.svg" alt="Increase quantity" class="qty-btn__icon" />
                                        </button>
                                    </div>
                                    <button
                                        class="add-to-cart-btn"
                                        (click)="
                                            onAddToCart(
                                                product.productId,
                                                variant.id,
                                                getQuantity(
                                                    product.productId,
                                                    variant.id
                                                )
                                            )
                                        "
                                    >
                                        <img
                                            alt="Add to Cart"
                                            src="assets/icons/cart-icon-white.svg"
                                            class="cart-icon"
                                        />
                                    </button>
                                </div>
                                <span class="moq-text" *ngIf="!hasMinQ(variant) && getMoq(variant) > 1">
                                    {{ TEXT.MOQ_PREFIX }} {{ getMoq(variant) }} {{ TEXT.MOQ_SUFFIX }}
                                </span>
                                <span class="product-table__quantity-info" *ngIf="hasMinQ(variant)">
                                    {{ getQuantityInfoText(variant) }}
                                </span>
                                <span class="product-table__quantity-info" *ngIf="getBundleLabel(variant, product) as bundleLabel">
                                    {{ bundleLabel }}
                                </span>
                            </div>
                            <div class="product-list__blur-overlay" *ngIf="guestCellBlur"></div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <div *ngIf="getVisibleVariants().length > 1 && !supplierId" class="show-more-container">
            <button
                class="show-more-btn"
                (click)="toggleShowAllOffers(product)"
            >
                <img
                    *ngIf="!isShowingAllOffers(product)"
                    src="assets/icons/plus-circle.svg"
                    alt="Show more offers"
                    class="show-more-btn__icon"
                />
                <img
                    *ngIf="isShowingAllOffers(product)"
                    src="assets/icons/minus-circle-icon.svg"
                    alt="Show less offers"
                    class="show-more-btn__icon"
                />
                {{
                    isShowingAllOffers(product)
                        ? "Show less offers"
                        : "Show more offers"
                }}
            </button>
        </div>
    </ng-container>
</div>
